import React from 'react';
import Portrait from './IMG_8203 2.JPG'
class About extends React.Component {
    render() {
        return (

            <div class="absolute w-full h-full bg-teal-800 top-[100%]">
                
                <div class="absolute top-1/2 left-1/3 transform -translate-x-1/3 -translate-y-1/2 ">
                    <div class="text-gray-400 w-[130%]">
                    <div class="text-3xl">About Me</div>
               
                </div>
                
                </div>
            </div>
        )
    }
}
export default About;